import {
  TComponentKeys,
} from '@/types/openapi-type.ts';

const tooltip: TComponentKeys<'AuditTrailSettings'> = {
  isEnabled: 'Entscheidet ob der Prüfpfad aktiviert ist. Wenn er ausgeschaltet ist, werden keine Ereignisse aufgezeichnet.',
  retentionPeriodDays: 'Definiert wie lang die Ereignisse vorgehalten werden. Alte Ereignisse werden stündlich gelöscht. Der maximale Zeitraum is 31 Tage.',
};

export default {
  tooltip,
};
